import { render, staticRenderFns } from "./FeaturesMenu.vue?vue&type=template&id=0b29ad08&scoped=true"
import script from "./FeaturesMenu.vue?vue&type=script&lang=ts"
export * from "./FeaturesMenu.vue?vue&type=script&lang=ts"
import style0 from "./FeaturesMenu.vue?vue&type=style&index=0&id=0b29ad08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29ad08",
  null
  
)

export default component.exports